import { render } from "./GeneraFattureClientiGas.vue?vue&type=template&id=d146cde2&scoped=true"
import script from "./GeneraFattureClientiGas.vue?vue&type=script&lang=js"
export * from "./GeneraFattureClientiGas.vue?vue&type=script&lang=js"

import "./GeneraFattureClientiGas.vue?vue&type=style&index=0&id=d146cde2&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d146cde2"]])

export default __exports__